import { getAccount } from 'wagmi/actions';

import { walletWagmiConfig } from './config';

/**
 * The currently connected EOA, read synchronously outside React. Wagmi
 * restores the persisted account optimistically while reconnecting, so a
 * page-reload click still sees the address; a genuinely disconnected wallet
 * reads undefined. Errors (e.g. AppKit failed to initialise in this browser)
 * read as no connection.
 */
export function readConnectedAddress(): string | undefined {
    try {
        return getAccount(walletWagmiConfig).address;
    } catch {
        return undefined;
    }
}
